import * as React from 'react';
import {FunctionComponent} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import 'react-dates-gte-react-17/initialize';
import 'react-dates-gte-react-17/lib/css/_datepicker.css';
import {WorkoutIndex} from './Workouts/WorkoutIndex';
import {Dashboard} from './Dashboard/Dashboard';
import {WorkoutShowContainer} from './Show/WorkoutShowContainer';
import {WorkoutShareContainer} from './Share/WorkoutShareContainer';
import {WorkoutShowByTokenContainer} from './Token/WorkoutShowByTokenContainer';
import {CrewsIndex} from './Crews/Index/CrewsIndex';
import {CrewsIndexCalendar} from './Crews/Index/Calendar/CrewsIndexCalendar';
import {CrewShowCalendarContainer} from './Crews/Show/Calendar/CrewShowCalendarContainer';
import {CrewMembersContainer} from './Crews/Members/CrewMembersContainer';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import {CrewShowContainer} from './Crews/Show/CrewShowContainer';
import {FeatureFlags} from '../FeatureFlags';
import {SnippetShowContainer} from './Snippets/SnippetShowContainer';
import {ReportShowPreviewContainer} from './Report/Show/ReportShowPreviewContainer';
import {ReportsIndex} from './Report/Index/ReportsIndex';
import {ReportShowContainer} from './Report/Show/ReportShowContainer';

let ErrorBoundary: any = ({children}: any) => children;
if (process.env.MIX_BUGSNAG_API_KEY) {
    Bugsnag.start({
        apiKey: process.env.MIX_BUGSNAG_API_KEY,
        plugins: [new BugsnagPluginReact()],
    });
    ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);
}

const ErrorView = () => (
    <div className="container">
        <div className="row">
            <div className="col-12 text-center">
                <h1 className="mb-5">Error</h1>
                <h2>This shouldn't have happened</h2>
                <p>Something went wrong on our side. We have been notified and we will be working to fix this issue.</p>
            </div>
        </div>
    </div>
);

interface OwnProps {}

export const Root: FunctionComponent<OwnProps> = ({}) => {
    //Make sure to update the main navigation active link when the user navigates using the browser back/forward buttons.
    window.addEventListener('popstate', () => {
        const path = window.location.pathname;
        const mainNavLinks = document.querySelectorAll('.mainnav__list a');
        mainNavLinks.forEach((link) => {
            const href = link.getAttribute('href');
            const pathFromHref = href?.replace(window.location.origin, '');

            if (pathFromHref === path) {
                link.classList.add('mainnav__listitem--active');
            } else {
                link.classList.remove('mainnav__listitem--active');
            }
        });
    });

    return (
        <ErrorBoundary FallbackComponent={ErrorView}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/home" element={<Dashboard />} />
                    {FeatureFlags.crews && <Route path="/crews" element={<CrewsIndex />} />}
                    {FeatureFlags.crews && <Route path="/crews/calendar" element={<CrewsIndexCalendar />} />}
                    {FeatureFlags.crews && <Route path="/crews/:id" element={<CrewShowContainer />} />}
                    {FeatureFlags.crews && <Route path="/crews/:id/calendar" element={<CrewShowCalendarContainer />} />}
                    {FeatureFlags.crews && <Route path="/crews/:id/members" element={<CrewMembersContainer />} />}
                    <Route path="/workouts" element={<WorkoutIndex />} />
                    <Route path="/workouts/:id" element={<WorkoutShowByTokenContainer />} />
                    <Route path="/workouts/show/:id" element={<WorkoutShowContainer />} />
                    <Route path="/reports" element={<ReportsIndex />} />
                    {FeatureFlags.reports && <Route path="/reports/:id" element={<ReportShowContainer />} />}
                    {FeatureFlags.reports && <Route path="/reports/preview" element={<ReportShowPreviewContainer />} />}
                    {FeatureFlags.snippets && <Route path="/snippets/:id" element={<SnippetShowContainer />} />}
                    <Route path="/share/:hash/:id" element={<WorkoutShareContainer />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
};
